interface Icons {
	[key: string]: string;
}

export const LUT_ICONS: Icons = {
	"arrow-left": "fa-solid fa-arrow-left",
	"arrow-right": "fa-solid fa-arrow-right",
	"arrow-right-long": "fa-solid fa-arrow-right-long",
	bars: "fa-regular fa-bars",
	"chrevron-down": "fa-regular fa-chevron-down",
	"chevron-left": "fa-regular fa-chevron-left",
	"chevron-right": "fa-regular fa-chevron-right",
	"calendar-plus": "fa-solid fa-calendar-plus",
	cube: "fa-solid fa-cube",
	download: "fa-solid fa-download",
	envelope: "fa-solid fa-envelope",
	"external-link": "fa-solid fa-external-link",
	list: "fa-solid fa-list",
	location: "fa-solid fa-location-dot",
	map: "fa-solid fa-map",
	maximize: "fa-solid fa-arrows-maximize",
	times: "fa-regular fa-times",
	rhombus: "fa-solid fa-rhombus",
	"ruler-triangle": "fa-solid fa-ruler-triangle",
	warehouse: "fa-solid fa-warehouse",
	plus: "fa-solid fa-plus",
	minus: "fa-solid fa-minus",
	"magnifying-glass": "fa-solid fa-magnifying-glass",
	"earth-europe": "fa-solid fa-earth-europe",
	_default: "fa-solid fa-hashtag",
};

export const getIcon = (icon: string): string => {
	return LUT_ICONS[icon] ?? LUT_ICONS["_default"];
};

export const getLocationIconTypes = (type: string): string => {
	const types: Icons = {
		building: "warehouse",
		project: "ruler-triangle",
		unit: "rhombus",
	};

	return types[type] ?? "";
};
